import React, { Component } from "react";
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import {UpdateFormInReducer,resetAllocationPools} from "../../../actions";
import { Form, Select, Row, Col } from 'antd';
import { dataFormatter } from "../../CommonComponents/dataFormatter";
import {
  GrantAgreementSectionLastHeading,
  InputWrapper,
  LabelWrapper,
  GrantAgreementDropdown,
  GrantAgreementSubContent,
  WrapLabel,
  SelectOptionWrapper,
  HideArrow,
  ContentWrapper,
  DropDownWrapper,
  GrantAgreementInvestmentSectionLastHeading
} from "../styles";
import { investmentPreferenceState } from "../../../selectors";

class InvestmentPreference extends Component {

  onDropDownChange = (value) => {
    if (this.props.accountData && value === 'weightedPercentage')
    {
      let total = 0;
        let portfolioSolutionForm = dataFormatter(this.props.accountData.portfolioSolutions, this.props.isInitialContrib);
        total += portfolioSolutionForm["totalPercent"];
        let portfolioBuilderForm = dataFormatter(this.props.accountData.portfolioBuilders, this.props.isInitialContrib);
        total += portfolioBuilderForm["totalPercent"];
        let valueDrivenInvestmentForm = dataFormatter(this.props.accountData.valueDriven, this.props.isInitialContrib);
        total += valueDrivenInvestmentForm["totalPercent"];
        total = this.props.isInitialContrib ? 100 : total;
      this.props.UpdateForm(portfolioSolutionForm)(portfolioBuilderForm)(valueDrivenInvestmentForm)(total)(value);
    }else{
      this.props.resetAllocationPools();
    }
  }



  render() {
    const { Option } = Select;
    const { getFieldDecorator } = this.props.form;
    let dropDownValue = (this.props.grantAllocationDropdown === "") ? undefined : this.props.grantAllocationDropdown;
    
    return (
      <Form hideRequiredMark data-test="wrapper">
        <Row>
          <Col>
            <GrantAgreementInvestmentSectionLastHeading>Investment Options</GrantAgreementInvestmentSectionLastHeading>
            <GrantAgreementSubContent>Recommend how proceeds for the contribution are invested in the account. </GrantAgreementSubContent>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 8 }} md={{ span: 8 }}>
            <HideArrow>
              <WrapLabel>
                <Form.Item
                  label={<LabelWrapper>Select allocation preference</LabelWrapper>}
                >
                  {getFieldDecorator('grant purpose', {
                    rules: [
                      {
                        required: true,
                        message: 'Please select the purpose!'
                      }
                    ],
                  })(
                    <InputWrapper>
                      <DropDownWrapper id="grantAllocation" className="relative">
                        <GrantAgreementDropdown
                          onChange={this.onDropDownChange}
                          value={dropDownValue}
                          aria-label="investmentPreference"
                          role={false}
                          getPopupContainer={() => document.getElementById("grantAllocation")}
                        >
                          <Option value="weightedPercentage">
                            <SelectOptionWrapper>
                              Allocation by weighted percentage
                           </SelectOptionWrapper>
                          </Option>
                          <Option value="customPercentage">
                            <SelectOptionWrapper>
                              Allocation by custom percentage
                        </SelectOptionWrapper>
                          </Option>
                        </GrantAgreementDropdown>
                      </DropDownWrapper>
                    </InputWrapper>
                  )}
                </Form.Item>
              </WrapLabel>
            </HideArrow>
          </Col>
        </Row>
        <div>
          <ContentWrapper>
          The specified contribution will be allocated based on the percentage you enter below. 
        </ContentWrapper>
        </div>
      </Form>
    )
  }
}

const InvestmentPreferenceForm = Form.create({ name: 'grantAllocation' })(InvestmentPreference);

InvestmentPreferenceForm.propTypes = {
  accountData: PropTypes.object,
  grantAllocationDropdown: PropTypes.string,
  grantAllocation: PropTypes.object,
  dummyData: PropTypes.string,
  isInitialContrib: PropTypes.bool,
  UpdateForm: PropTypes.func,
  resetAllocationPools: PropTypes.func,
}

const mapStateToProps = state => (
  {
    ...investmentPreferenceState(state.toJS())
  }
);

export const mapDispatchToProps = dispatch => {
  return {
    UpdateForm: (portfolioSolutionForm) => (portfolioBuilderForm) => (valueDrivenInvestmentForm) => (total) => (value) => {
      dispatch(UpdateFormInReducer({portfolioSolutionForm,portfolioBuilderForm,valueDrivenInvestmentForm, total}))
    },
    resetAllocationPools: () => dispatch(resetAllocationPools()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(InvestmentPreferenceForm);
